import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'generic-banner',
  templateUrl: 'genericBanner.component.html',
  styleUrls: [],
  providers: []
})
export class GenericBannerComponent implements OnInit {
  icons = {
    faWarning
  }
  @Input() title ? : string; 
  @Input() text ?: string;
  @Input() show ?: boolean;
  @Input() textInnerHTML ? : string;


  ngOnInit(): void {
  }
}
